import { Pipe, PipeTransform } from '@angular/core';
import { formatTimeBasedOnTimezone } from '../utils/date-time.util';

@Pipe({
	name: 'istUtcDate',
	standalone: true
})
export class IstUtcDatePipe implements PipeTransform {
	transform(utcDateString: string | undefined): string {
		if (!utcDateString) return '';
		return formatTimeBasedOnTimezone(utcDateString);
	}
}